<div class="calendar-wrapper" *ngIf="calendarOptions">
    <div id="ucCalendar"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-calendar-view/maintenance-calendar-calendar-view.component.html